{
  "_note": "Stationen der 3D-Welt. sources = Emissionsquellen aus dem Modell, ghg = Kategorie nach GHG Protocol.",
  "stations": {
    "factory": {
      "label": "Ihr Werk",
      "scope": "1+2",
      "ghg": "Scope 1 + 2",
      "sources": ["heat", "fleet", "power"],
      "text": "Direkte Emissionen aus Heizung, Prozesswärme und Fuhrpark (Scope 1) sowie eingekaufter Strom (Scope 2).",
      "method": "Zählerstände und Rechnungen × Emissionsfaktor. Gut messbar – meist der kleinere Teil.",
      "quality": "B"
    },
    "power_plant": {
      "label": "Energieversorger",
      "scope": "3",
      "ghg": "Kat. 3 – Brennstoff- und energiebezogene Emissionen",
      "sources": ["upstream_energy"],
      "text": "Förderung, Transport und Netzverluste Ihrer Energie – bevor sie bei Ihnen ankommt.",
      "method": "Vorkettenfaktoren auf Ihren Energieverbrauch. Sinkt automatisch mit Scope 1 + 2.",
      "quality": "C"
    },
    "steel_mill": {
      "label": "Stahl- & Metallwerk",
      "scope": "3",
      "ghg": "Kat. 1 – Eingekaufte Waren",
      "sources": ["metals"],
      "text": "Stahl, Aluminium, Guss- und Blechteile. Die Herstellung ist sehr energieintensiv.",
      "method": "Ohne Daten: Einkaufsvolumen × EXIOBASE-Faktor (spend-based). Besser: Gewicht × Materialfaktor oder Produkt-EPD.",
      "quality": "D"
    },
    "chem_plant": {
      "label": "Kunststoff- & Verpackungswerk",
      "scope": "3",
      "ghg": "Kat. 1 – Eingekaufte Waren",
      "sources": ["plastics", "packaging"],
      "text": "Granulate, Chemikalien, Folien, Kartonagen und Paletten.",
      "method": "Ohne Daten: spend-based. Besser: Materialzusammensetzung aus Datenblättern und Stücklisten.",
      "quality": "D"
    },
    "component_works": {
      "label": "Zulieferer & Hersteller",
      "scope": "3",
      "ghg": "Kat. 1 – Eingekaufte Waren",
      "sources": ["components", "goods"],
      "text": "Motoren, Antriebe, Elektronik und Handelsware von Ihren Lieferanten.",
      "method": "Hersteller identifizieren, Produkt-EPD suchen, sonst Materialmodell aus Gewicht und Typ.",
      "quality": "D"
    },
    "farm": {
      "label": "Landwirtschaft & Zutaten",
      "scope": "3",
      "ghg": "Kat. 1 – Eingekaufte Waren",
      "sources": ["agri", "food"],
      "text": "Milch, Getreide, Fleisch und Zutaten. Methan und Dünger machen Agrarrohstoffe besonders emissionsreich.",
      "method": "Mengen × Produktfaktor statt Euro × Sektorfaktor.",
      "quality": "D"
    },
    "quarry": {
      "label": "Zement- & Baustoffwerk",
      "scope": "3",
      "ghg": "Kat. 1 – Eingekaufte Waren",
      "sources": ["building"],
      "text": "Zement, Beton, Ziegel und Glas. Bei der Zementherstellung entsteht CO2 auch chemisch aus dem Kalkstein.",
      "method": "Massen aus dem Leistungsverzeichnis × EPD aus ÖKOBAUDAT.",
      "quality": "D"
    },
    "office_park": {
      "label": "Dienstleister & IT",
      "scope": "3",
      "ghg": "Kat. 1 – Eingekaufte Dienstleistungen",
      "sources": ["services"],
      "text": "Software, Cloud, Beratung, Reinigung, Wartung.",
      "method": "Meist spend-based – Dienstleistungen haben je Euro geringe Emissionen.",
      "quality": "D"
    },
    "logistics_hub": {
      "label": "Logistik",
      "scope": "3",
      "ghg": "Kat. 4 + 9 – Transport und Verteilung",
      "sources": ["logistics"],
      "text": "LKW, Bahn und Schiff – vom Lieferanten zu Ihnen und von Ihnen zum Kunden.",
      "method": "Tonnenkilometer × Verkehrsträgerfaktor oder Frachtkosten × EXIOBASE.",
      "quality": "C"
    },
    "airport": {
      "label": "Flughafen",
      "scope": "3",
      "ghg": "Kat. 6 – Geschäftsreisen",
      "sources": ["travel"],
      "text": "Flüge, Hotels und Dienstreisen Ihrer Mitarbeitenden.",
      "method": "Reisekostenabrechnung: Strecken × Faktor je Verkehrsmittel.",
      "quality": "C"
    },
    "suburb": {
      "label": "Wohnort der Belegschaft",
      "scope": "3",
      "ghg": "Kat. 7 – Pendeln der Mitarbeitenden",
      "sources": ["commute"],
      "text": "Der tägliche Weg zur Arbeit – mit Auto, Bahn, Rad oder gar nicht (Homeoffice).",
      "method": "Kurze Mitarbeiterumfrage: Entfernung und Verkehrsmittel.",
      "quality": "C"
    },
    "customers": {
      "label": "Ihre Kunden",
      "scope": "3",
      "ghg": "Kat. 11 – Nutzung verkaufter Produkte",
      "sources": ["use_phase"],
      "text": "Energie, die Ihre Produkte über ihre Lebensdauer beim Kunden verbrauchen. Bei Maschinen oft der größte Block überhaupt.",
      "method": "Leistung × Betriebsstunden × Lebensdauer × Strommix.",
      "quality": "C"
    },
    "recycling": {
      "label": "Recycling & Entsorgung",
      "scope": "3",
      "ghg": "Kat. 5 + 12 – Abfall und Lebensende",
      "sources": ["waste", "end_of_life"],
      "text": "Ihre Betriebsabfälle und was am Ende mit Ihren Produkten passiert.",
      "method": "Abfallmengen nach Fraktion × Entsorgungsweg.",
      "quality": "C"
    }
  }
}
